import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple,DateTimeFormat } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '设备编号',
      dataIndex: 'deviceNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deviceNumber ? t.deviceNumber : '-'
      },
    },
    {
      title: '设备名称',
      dataIndex: 'deviceName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deviceName ? t.deviceName : '-'
      },
    },
    {
      title: '规格型号',
      dataIndex: 'model',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.model ? t.model : '-'
      },
    },
    {
      title: '启动时间',
      dataIndex: 'startTime',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.startTime ? moment(t?.startTime).format(DateTimeFormat): '-'
      },
    },
    {
      title: '停止时间',
      dataIndex: 'stopTime',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.stopTime ? moment(t?.stopTime).format(DateTimeFormat): '-'
      },
    },
    {
      title: '运转情况',
      dataIndex: 'runningStatus',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.runningStatus ? t.runningStatus : '-'
      },
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.operator ? t.operator : '-'
      },
    }, 
     {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
